import styled from "styled-components";
import { flex, responsive } from "../../mixins";

export const Wrapper = styled.div`
  ${flex({ flexDirection: "row" })}
  gap: 0.5rem;
  margin-top: 5px;
  h4 {
    padding-top: 8px;
    color: #e0296c;
  }
  span {
    font-weight: bold;
  }
  ${responsive.tablet.standard`
    h4:nth-child(1) {
      display: none;
    }
  `}
`;
